




































































































import { Component, ProvideReactive, Ref, Vue } from 'vue-property-decorator';
import { SmartQuery } from 'vue-apollo-decorator';
import ProductGroupOrganizer from './ProductGroupOrganizer.vue';
import { GQL_allProductGroupsListEdit, GQL_allProductGroupsListEdit_currentUnit } from '@/queries/__generated__/allProductGroupsListEdit';
import { PRODUCT_LIST_SEARCH, UPDATE_PRODUCT } from '@/queries/Product';
import SApolloTable from '../UI/Table/SApolloTable.vue';
import { GQL_productListSearch_products } from '@/queries/__generated__/productListSearch';
import { GQL_product_product } from '@/queries/__generated__/product';
import { sortProductGroups } from '@/app/ProductGroup';
import gql from 'graphql-tag';

const ALL_PRODUCT_GROUPS_LIST_EDIT = gql`
  query allProductGroupsListEdit {
    currentUnit {
      id
      productGroups {
        id
        name
        fullPathName
        subgroups {
          id
        }
        parentGroup {
          id
        }
        products {
          id
          name
          number
        }
      }
    }
  },
`;

export type ProductGroup = {
  id: string;
  name: string;
  fullPathName: string;
  parentGroupId: string | null;
  subgroups: ProductGroup[];
  products: {
    id: string;
    name: string;
    number: string;
    productGroupId: string | null;
  }[];
}

@Component({
  components: {
    ProductGroupOrganizer,
  },
})
export default class ProductGroupListEdit extends Vue {
  private PRODUCT_LIST_SEARCH = PRODUCT_LIST_SEARCH;
  @Ref() private ungrouped_table?: SApolloTable<GQL_productListSearch_products>;

  @SmartQuery<ProductGroupListEdit, GQL_allProductGroupsListEdit>({
    query: ALL_PRODUCT_GROUPS_LIST_EDIT,
    result(data) {
      this.productGroupsMap = new Map();
      data.data.currentUnit.productGroups.forEach(group => {
        this.productGroupsMap!.set(group.id, {
          id: group.id,
          name: group.name,
          fullPathName: group.fullPathName,
          parentGroupId: group.parentGroup?.id || null,
          subgroups: [],
          products: group.products!.map(product => ({
            id: product.id,
            name: product.name,
            number: product.number,
            productGroupId: group.id || null,
          })),
        });
      });

      this.allProductGroups = sortProductGroups(Array.from(this.productGroupsMap!.values()));

      this.rootProductGroups = [];
      data.data.currentUnit.productGroups.forEach(gqlGroup => {
        const group = this.productGroupsMap!.get(gqlGroup.id)!;

        group.subgroups = sortProductGroups(gqlGroup.subgroups!.map(s => this.productGroupsMap!.get(s.id)!));

        if (!group.parentGroupId) {
          this.rootProductGroups!.push(group);
        }
      });

      this.rootProductGroups = sortProductGroups(this.rootProductGroups);
    },
    fetchPolicy: 'no-cache',
  }) private currentUnit?: GQL_allProductGroupsListEdit_currentUnit;

  private ungroupedProductsExpanded = false;

  private updateGroupForUngroupedProduct(product: GQL_product_product, productGroupId: string) {
    this.$apollo.mutate({
      mutation: UPDATE_PRODUCT,
      variables: {
        id: product.id,
        productGroupId: productGroupId,
      },
    }).then(() => {
      this.$apollo.queries.currentUnit.refetch();
      this.ungrouped_table?.refetch();
    });
  }

  @ProvideReactive()
  private productGroupsMap: Map<string, ProductGroup> | null = null;
  private rootProductGroups: ProductGroup[] | null = null;

  @ProvideReactive()
  private allProductGroups: ProductGroup[] | null = null;

}
